const FETCH_PLANS_INFO = 'landing-zona-demand/plans/FETCH_PLANS_INFO';
const FETCH_PLANS_INFO_COMPLETED = 'landing-zona-demand/plans/FETCH_PLANS_INFO_COMPLETED';
const FETCH_PLANS_INFO_FAILED = 'landing-zona-demand/plans/FETCH_PLANS_INFO_FAILED';

export { FETCH_PLANS_INFO, FETCH_PLANS_INFO_COMPLETED, FETCH_PLANS_INFO_FAILED };
